export default "__VITE_ASSET__C1Owg0I0__"